<template>
  <div>
    <div class="img-top">
      <img src="https://img.bosch-extra.com.cn/upload/BE/7215f466-2293-4ba5-897f-96de34b41625.png">
    </div>
    <div class="point-text">您的活动积分余额：{{ clientPoint }}</div>

    <div class="product">
      <div class="product-item" v-for="(item, index) in productList" :key="index">
        <div class="product-left">
          <img :src="getPrizeImg(item.imageName)">
          <!-- <img src="../../../assets/images/2021/booth-prize-1.png" /> -->
          <div class="product-info">
            <div class="product-name">{{ item.productName }}</div>
            <div class="product-value">{{ item.pointValue }}积分</div>
          </div>
        </div>
        <van-button size="small" type="default" class="product-operation" @click="handleOperation(item.productType, item.productId)">
          {{ getProductType(item.productType) }}
        </van-button>
      </div>
    </div>

    <van-dialog
      v-model="initDialog"
      show-confirm-button
      confirm-button-text="确定"
      @confirm="initDialog=false"
    >
      <div class="dialogContext">您已兑换成功！点击去分享，分享成功后打开分享链接，展示兑换编号给工作人员领取礼品。</div>
    </van-dialog>

        <van-dialog
      v-model="showExchangeBox"
      show-confirm-button
      confirm-button-text="确定"
      showCancelButton
      cancelButtonText="取消"
      @confirm="handleExchange()"
      @close ="showExchangeBox=false"
    >
      <div class="dialogContext">是否兑换该礼品</div>
    </van-dialog>

    <van-dialog
      v-model="showShareBox"
      show-confirm-button
      confirm-button-text="立即分享"
      cancelButtonText="取消"
      @confirm="showOverlay = true"
      @close ="showShareBox=false"
    >
      <div class="dialogContext">恭喜您兑换成功，分享领取奖励。</div>
    </van-dialog>

    <van-dialog
      v-model="showConfirmBox"
      show-confirm-button
      confirm-button-text="确定"
      @confirm="showConfirmBox = true"
    >
      <div class="dialogContext">您已兑换了礼品</div>
    </van-dialog>

    <van-overlay :show="showOverlay" @click="showOverlay = false" z-index="99">
      <div class="overlay-wrapper">
          <div class="text">
            点击页面右上角分享,分享成功后打开分享链接，展示兑换编号给工作人员领取礼品。
          </div>
          <img
            class="arrow"
            src="../../../assets/images/extra-style/arrow.png"
          />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import { sessionStorageUtils } from '@/utils/sessionstorage'
import { commonUtils } from '@/utils/common'
export default {
  created () {
    this.init('init')
  },
  mounted () {
    // this.initWxJsSdk()
  },
  data () {
    return {
      productList: [],
      clientPoint: '',
      showShareBox: false,
      showOverlay: false,
      openId: '',
      showConfirmBox: false,
      showExchangeBox: false,
      productId: '',
      imageName: '',
      initDialog: false
    }
  },
  methods: {
    async init (time) {
      let wxUserInfo = sessionStorageUtils.get('wxUserInfo') || ''
      this.openId = wxUserInfo.openId
      let params = {
        openId: this.openId
      }
      let { data } = await activityApi.boothInquire(params)

      if (data.resultCode === '0') {
        this.productList = data.resultData.productList
        this.clientPoint = data.resultData.clientPoint
        if (data.resultData.imageName) {
          this.imageName = data.resultData.imageName
          if (time === 'init') { this.initDialog = true }
        }
      }

      this.initWxJsSdk()
    },
    getProductType (type) {
      if (type === '2') {
        return '兑换'
      } else if (type === '3') {
        return '去分享'
      } else if (type === '4') {
        return '已兑换'
      }
    },
    getPrizeImg (img) {
      return 'https://img.bosch-extra.com.cn' + img
    },
    handleOperation (type, productId) {
      if (type === '2') {
        this.showExchangeBox = true
        this.productId = productId
      } else if (type === '3') {
        this.showOverlay = true
      } else if (type === '4') {
        this.showConfirmBox = true
      }
    },
    handleExchange () {
      let data = {
        openId: this.openId,
        productId: this.productId
      }
      activityApi.boothExchange(data).then(res => {
        if (res.data.resultCode === '0') {
          console.log(res)
          this.init()
          // this.initWxJsSdk()
          this.showShareBox = true
        }
      })
    },
    // 初始化微信jssdk
    initWxJsSdk () {
    // console.log(window.__wxjs_is_wkwebview)
    // ios系统下，进行wx jssdk验证的url 应为第一次进入页面时的url
      console.log('初始化微信jssdk')
      let sdkUrl = null
      const u = navigator.userAgent
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        sdkUrl = global.entryUrl
      }
      const url = `${document.location.origin}/v2/activity/2021/activity-booth-share?openId=${this.openId}`

      console.log(sdkUrl)

      let imgUrl = ''
      let title = ''
      console.log(process.env.VUE_APP_FILE_SERVER + '/upload/83/ad18ec8f-55e0-4a08-9e65-d4330dcddf01.jpg')
      if (this.imageName === '') {
        imgUrl = process.env.VUE_APP_FILE_SERVER + '/upload/83/ad18ec8f-55e0-4a08-9e65-d4330dcddf01.jpg'
        title = '快来和我一起免费兑换礼品！'
      } else {
        imgUrl = process.env.VUE_APP_FILE_SERVER + this.imageName
        title = '快看，我在易加网兑换了一件礼品！'
      }

      const appMessageShare = {
        title: title, // 分享标题
        desc: '礼品兑换、促销信息、品牌资讯、新品介绍、迷你培训，尽在易加！', // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
        // 用户点击了分享后执行的回调函数
          console.log('appMessageShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail')
        }
      }

      const timelineShare = {
        title: title, // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function () {
        // 用户点击了分享后执行的回调函数
          console.log('timelineShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail' + url)
        }
      }
      commonUtils.configWxJsSdk(appMessageShare, timelineShare, sdkUrl).then(() => {
        this.wxReady = true
      }).catch(error => {
        this.$emit('error', { errorMsg: error })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.van-button--default {
    color: #ffffff;
    background-color: #0091A0;
    border: 0;
}
.img-top img{
  width: 100%;
}
.point-text{
  margin: 15px;
  color:red;
}
.product-item {
  height: 80px;
  width: calc(100% - 40px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px 0 10px;
  margin-bottom: 5px;
  background-color: white;
  //justify-content: space-around;
  .product-left {
    display: flex;
    width: 80%;
    img{
      width: 70px;
      height: 70px;
    }
    .product-info{
      margin: 0 20px;
      line-height: 20px;
      .product-name{
        font-size: 14px;
      }
      .product-value{
        color: red;
        font-weight: 600;
      }
    }
  }
  .product-operation{
    min-width: 60px;
  }
}
.overlay-wrapper {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  height: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  display: flex;
  .text{
    margin-top: 70px;
    margin-left: 15px;
  }
  .arrow {
    //position: absolute;
    top: 0;
    padding-left: 10px;
    width: 80px;
    height: 80px;
  }
}
</style>
